module.exports = __webpack_public_path__ + "static/img/logo_w.bfee5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_w.png
// module id = JPtW
// module chunks = 18